import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import Zone from "../../components/assets/ZoneComponent";
import Site from "../../components/assets/SiteList";
import SwapStation from "../../components/assets/SwapStationList";
import MakersList from "../../components/assets/MakersList";
import ModelList from "../../components/assets/ModelsList";
import VehicleList from "../../components/assets/VehicleList";
import Battery from "../../components/assets/BatteryList";
import styles from "./Asset.module.scss";
import { Link, useHistory, useLocation } from "react-router-dom";

import Master from "../Master";

var tempTigger;
var tabTemp = "inactive";

function AssetComponent(props) {
  const history = useHistory();

  const [table, setTable] = useState(
    props.location?.state?.table ? props.location.state.table : 0
  );

  const [assetCount, setAssetCount] = useState(0);

  useEffect(() => {
    tabTemp = "inactive";
    tempTigger = !props.history?.location?.state?.compomentRenderType
      ? "init"
      : props.history?.location?.state?.compomentRenderType === "amhitted"
      ? "amhitted"
      : props.history?.location?.state?.compomentRenderType === "view"
      ? "view"
      : "init";
    localStorage.setItem("activeTabCount", table == 0 ? "zoneAsset" : "other");
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  useEffect(() => {
    window.onload = () => {
      setTable(0);
    };
  }, []);

  return (
    <>
      <h2
        id="Assets_header_text"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Assets"}
      </h2>

      <div
        id="Subtitle_text_block"
        className={cn(styles.flex2, styles.flex2_layout)}
      >
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_Zones"
            className={
              table === 0
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle4, styles.subtitle1_layout)
            }
            onClick={() => {
              setTable(0);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "zoneAsset");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Zones"}
          </h3>
        </div>
        <div className={cn(styles.flex2_spacer)} />
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_sites"
            className={
              table === 1
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle2, styles.subtitle2_layout)
            }
            onClick={() => {
              setTable(1);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "otherAssets");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Sites"}
          </h3>
        </div>
        <div className={cn(styles.flex2_spacer1)} />
        {/* <Link to="/Assets/SwapStationList"> */}
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_SwapStation"
            className={
              table === 2
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle2, styles.subtitle2_layout)
            }
            onClick={() => {
              setTable(2);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "otherAssets");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Swap Stations"}
          </h3>
        </div>
        {/* </Link> */}
        <div className={cn(styles.flex2_spacer2)} />

        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_Batteries"
            className={
              table === 3
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle2, styles.subtitle2_layout)
            }
            onClick={() => {
              setTable(3);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "otherAssetsBattery");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Batteries"}
          </h3>
        </div>
        <div className={cn(styles.flex2_spacer)} />
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_Manufacturer"
            className={
              table === 4
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle4, styles.subtitle1_layout)
            }
            onClick={() => {
              setTable(4);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "manufacturerAsset");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Manufacturer"}
          </h3>
        </div>
        <div className={cn(styles.flex2_spacer)} />
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_Model"
            className={
              table === 5
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle4, styles.subtitle1_layout)
            }
            onClick={() => {
              setTable(5);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "modelAsset");
              localStorage.setItem("lastTableSearch", "");
            }}
            style={{ cursor: "pointer" }}
          >
            {"Model"}
          </h3>
        </div>
        <div className={cn(styles.flex2_spacer)} />
        <div id="Subtitle_text" className={cn(styles.flex2_item)}>
          <h3
            id="Subtitle_Heading_Vehicles"
            style={{ cursor: "pointer" }}
            className={
              table === 6
                ? cn(styles.subtitle, styles.subtitle_layout)
                : cn(styles.subtitle4, styles.subtitle1_layout)
            }
            onClick={() => {
              setTable(6);
              tabTemp = "active";
              localStorage.setItem("activeTabCount", "vehiclesAsset");
              localStorage.setItem("lastTableSearch", "");
            }}
          >
            {"Vehicles"}
          </h3>
        </div>
      </div>

      <div
        id="Total_count_block"
        className={cn(styles.flex3, styles.flex3_layout)}
      >
        <div id="Total_count_block1" className={cn(styles.flex3_item)}>
          <div
            id="Total_count_block2"
            className={cn(styles.block2, styles.block2_layout)}
          >
            <div id="Total_count_block3" className={cn(styles.block2_item)}>
              <div
                id="Total_count_block4"
                className={cn(styles.block4, styles.block4_layout)}
              >
                <div
                  id="Total_count_box"
                  className={cn(styles.box3, styles.box3_layout)}
                  style={{ backgroundColor: " rgb(64, 111, 211)" }}
                >
                  <img
                    id="Total_count_img"
                    src={
                      table === 0
                        ? require("assets/Zones 1.png").default
                        : table === 1
                        ? require("assets/SitesPage.svg").default
                        : table === 2
                        ? require("assets/SwapStationPage.svg").default
                        : table === 3
                        ? require("assets/BatteryPage.svg").default
                        : table === 4
                        ? require("assets/Enterprises.svg").default
                        : table === 5
                        ? require("assets/Enterprises.svg").default
                        : table === 6
                        ? require("assets/Enterprises.svg").default
                        : " "
                    }
                    alt="Rectangle 16663"
                    className={cn(styles.box1, styles.box1_layout)}
                  />
                </div>
              </div>
            </div>
            <div className={cn(styles.block2_spacer)} />
            <div id="Total_count_Heading" className={cn(styles.block2_item1)}>
              <div
                id="Total_count_Heading1"
                className={cn(styles.block3, styles.block3_layout)}
              >
                <h3
                  id="count_text"
                  className={cn(styles.subtitle1, styles.subtitle1_layout)}
                >
                  {"Total Count"}
                </h3>
                <h3
                  id="count_Number"
                  className={cn(styles.subtitle3, styles.subtitle3_layout)}
                >
                  {assetCount}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex3_spacer)} />

        <div className={cn(styles.flex3_item1)}>
          <Link
            to={
              table === 0
                ? "/Assets/AddZone"
                : table === 1
                ? "/Assets/AddSite"
                : table === 2
                ? "/Assets/AddSwapStation"
                : table === 3
                ? "/Assets/addBattery"
                : table === 4
                ? "/Assets/addMakers"
                : table === 5
                ? "/Assets/addModel"
                : table === 6
                ? "/Assets/addVehicle"
                : " "
            }
          >
            <div
              id="Add_Asset_button_layout"
              className={cn(styles.add_button7, styles.add_button7_layout)}
            >
              <div
                id="Add_Asset_button"
                className={cn(styles.add_button7_item)}
              >
                <div
                  id="Add_Asset_buttonBox"
                  className={cn(
                    styles.add_button_box6,
                    styles.add_button_box6_layout
                  )}
                >
                  <div
                    id="Add_Asset_buttonBox1"
                    className={cn(styles.add_button7_item)}
                  >
                    <img
                      src={require("assets/Vector (5).png").default}
                      alt="Rectangle 16663"
                    />
                  </div>
                </div>
              </div>

              <div className={cn(styles.add_button7_spacer)} />

              <div
                id="Add_Asset_buttonText"
                className={cn(
                  styles.add_button_text_body,
                  styles.add_button_text_body_layout
                )}
              >
                {table === 0
                  ? "Add Zone"
                  : table === 1
                  ? " Add Site"
                  : table === 2
                  ? "Add Swap Station"
                  : table === 3
                  ? "Add Battery"
                  : table === 4
                  ? "Add Manufacturer"
                  : table === 5
                  ? "Add Model"
                  : table === 6
                  ? "Add Vehicle"
                  : " "}
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div
      // className={cn(styles.flex4, styles.flex4_layout)}
      >
        {/* <div className={cn(styles.flex4_spacer)} /> */}
        {table === 0 ? (
          <Zone
            assetCount={setAssetCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 1 ? (
          <Site
            assetCount={setAssetCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 2 ? (
          <SwapStation
            assetCount={setAssetCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 3 ? (
          <Battery
            assetCount={setAssetCount}
            tigger={tempTigger}
            tabTemp={tabTemp}
            headerFilter={props.headerFilter}
          />
        ) : table === 4 ? (
          <MakersList
            assetCount={setAssetCount}
            headerFilter={props.headerFilter}
            tigger={tempTigger}
            tabTemp={tabTemp}
          />
        ) : table === 5 ? (
          <ModelList
            assetCount={setAssetCount}
            headerFilter={props.headerFilter}
            tigger={tempTigger}
            tabTemp={tabTemp}
          />
        ) : table === 6 ? (
          <VehicleList
            assetCount={setAssetCount}
            headerFilter={props.headerFilter}
            tigger={tempTigger}
            tabTemp={tabTemp}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default function Asset(props) {
  const [headerFilter, setHeaderFilter] = useState(true);

  return (
    <>
      <Master
        opts={{ ...props }}
        screen={AssetComponent}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

Asset.inStorybook = true;
